import Vue from 'vue';

export default {
  ads(state, ads) {
    state.ads.list = ads;
  },
  addAd(state, ad) {
    const exists = state.ads.list.find(({ _id }) => ad._id === _id);
    if (!exists) {
      state.ads.list = [ad].concat(...state.ads.list);
    }
  },
  updateAd(state, ad) {
    const adIndex = state.ads.list.findIndex(
      ({ _id }) => ad._id === _id
    );
    if (adIndex >= 0) {
      Vue.set(state.ads.list, adIndex, ad);
    }
  },
  removeAd(state, id) {
    const list = [...state.ads.list];
    const adIndex = list.findIndex(({ _id }) => id === _id);
    if (adIndex >= 0) {
      list.splice(adIndex, 1);
      Vue.set(state.ads, 'list', list);
    }
  },
};
